import { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import {
    TextField,
    Box,
    Backdrop,
    Stack,
} from '@mui/material';

import CustomButton from "../custom_components/CustomButton";
import CustomModalHeader from "../custom_components/CustomModalHeader";

const apiUrl = process.env.REACT_APP_API_URL;

const EditList = ({
    open,
    onClose,
    list,
    onUpdate,
}) => {

    const [listId, setListId] = useState("");
    const [listName, setListName] = useState("");
    const [listDate, setListDate] = useState("");

    const [isSaving, setIsSaving] = useState(false);

    useEffect(() => {
        if (!open) return;

        setListId(list?.ListID || "");
        setListName(list?.ListName || "");
        setListDate(list?.DateCreated || "");
    }, [open, list]);

    // SAVE LIST INFO
    const handleEditList = async () => {

        if (!listId || !listName || !listDate) {
            Swal.fire({
                text: "Please fill all the required inputs.",
                icon: "warning"
            });
            return;
        }

        setIsSaving(true);

        try {
            const response = await fetch(
                `${apiUrl}manage_list/edit_list.php`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        listId,
                        listName,
                        listDate
                    })
                }
            );

            const result = await response.json();

            if (result.status === "success") {

                onUpdate({
                    ListID: listId,
                    ListName: listName,
                    DateCreated: listDate
                });

                Swal.fire({
                    icon: "success",
                    text: result.message,
                    timer: 3500,
                    showConfirmButton: false
                });

                setListId("");
                setListName("");
                setListDate("");

                onClose();

            } else if (result.status === "error") {

                Swal.fire({
                    text: result.message,
                    icon: "error"
                });
            }

        } catch (error) {

            Swal.fire({
                title: "Error saving list!",
                text: error.message || "Something went wrong.",
                icon: "error"
            });

            console.error("Error saving list:", error);

        } finally {
            setIsSaving(false);
        }
    };

    return (
        <Backdrop
            aria-hidden="false"
            open={open}
            sx={{
                zIndex: (theme) => theme.zIndex.drawer + 1,
                backdropFilter: "blur(1px)",
            }}
        >

            <Box
                onClick={(e) => e.stopPropagation()}
                sx={{
                    width: 420,
                    backgroundColor: "#ffffff",
                    borderRadius: 2,
                    p: 2.5,
                    boxShadow: 6,

                    position: "relative",
                    overflow: "hidden",
                    "&::before": {
                        content: '""',
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "4px",
                        background: "#2e3489"
                    }
                }}
            >

                <CustomModalHeader
                    title="Edit List"
                    subtitle={`ID: ${listId}`}
                    onClose={onClose}
                />

                <Stack spacing={2.2}>
                    <TextField
                        label="List Name"
                        size='small'
                        value={listName}
                        onChange={(e) => setListName(e.target.value)}
                    />

                    <TextField
                        label="Date"
                        type="date"
                        size="small"
                        fullWidth
                        value={listDate}
                        onChange={(e) => setListDate(e.target.value)}
                    />
                </Stack>

                <Stack
                    direction="row"
                    justifyContent="right"
                    gap={2}
                    mt={4}
                >
                    <CustomButton
                        label="Cancel"
                        variant="outlined"
                        hoverColor="#d14249"
                        onClick={onClose}
                    />

                    <CustomButton
                        label={isSaving ? "Updating..." : "Save Changes"}
                        disabled={isSaving}
                        onClick={handleEditList}
                    />
                </Stack>

            </Box>

        </Backdrop>
    );
};

export default EditList;
